import ActionTypes, { TTechnicalTextsState } from './types';
import { Actions, TDefRequest } from '../Action';

const GetTechnicalTextsAction = new Actions('GET_TECHNICAL_TEXTS', ActionTypes);
export interface TypeGetTechnicalTextsActionR extends TDefRequest {
  data: {
    event_id: number;
  };
}
export const GetTechnicalTexts = {
  request: (payload: TypeGetTechnicalTextsActionR) => GetTechnicalTextsAction.request(payload),
  success: (payload: TTechnicalTextsState['data']) => GetTechnicalTextsAction.success(payload || {}),
  error: (message: string) => GetTechnicalTextsAction.error(message),
};
